export type SearchParamsType = {
  filter: {
    searchText: string;
    status: number;
  };
  sortOrder: string;
  sortField: string;
  pageNumber: number;
  pageSize: number;
};

export type MasterTableDataType = {
  empId: number;
  clinicId: number;
  createdByDate: string;
  createdById: number;
  empCode: string;
  empName: string;
  empStatus: number;
};

export type MasterDataType = {
  clinicId: number;
  createdByDate: string;
  createdById: number;
  empCode: string;
  empId: number;
  empName: string;
  empStatus: number;
};

export type SaveResponseType = {};

export type MasterFormDataType = {
  empCode: string;
  empName: string;
  empStatus: number;
};

export const initialFormData: MasterFormDataType = {
  empCode: "",
  empName: "",
  empStatus: 1,
};

